import React from 'react';
import { Grid, Box, Skeleton } from '@mui/material';

const BookingAvailabilitySkeleton = () => (
  <Grid display="flex" flexDirection="column" alignItems="center" height="calc(100% - 68px)">
    <Grid gap={6} display="flex" flexDirection="column" alignItems="center">
      <Skeleton sx={{ borderRadius: '5px' }} variant="text" width={200} height={40} />
      <Skeleton sx={{ borderRadius: '5px' }} variant="text" width={542} height={20} />
    </Grid>
    <Grid
      display="flex"
      justifyContent="center"
      m="auto"
      gap={2}
      width="100%"
      flexDirection="column"
      maxWidth={542}
    >
      <Grid display="flex" flexDirection="row" gap="20px" ml="178px" />

      {[...Array(7)].map((e, _index) => (
        <Grid key={e} display="flex" flexDirection="row" gap="20px" alignItems="center">
          <Grid display="flex" flexDirection="row" gap="12px" alignItems="center">
            <Skeleton sx={{ borderRadius: '5px' }} variant="rectangular" width={20} height={20} />
            <Skeleton sx={{ borderRadius: '5px' }} variant="text" width={104} height={20} />
          </Grid>
          <Grid display="flex" flexDirection="row" gap="20px" width="100%">
            <Skeleton sx={{ borderRadius: '5px' }} variant="rectangular" width="50%" height={40} />
            <Skeleton sx={{ borderRadius: '5px' }} variant="rectangular" width="50%" height={40} />
          </Grid>
        </Grid>
      ))}
    </Grid>
  </Grid>
);

export default BookingAvailabilitySkeleton;
